import { useCookieUtils } from '@/shared/cookies.composable';
import { useAuth } from '@/auth/auth.composable';
import { ref } from 'vue';
import { API } from 'aws-amplify';

export function useRecaptchaHelpers() {
    return {
        validateRecaptchaToken,
        shouldShowRecaptcha,
        setEnableRecaptcha,
        recaptchaEnabled,
    }
}

const COOKIE_ID = 'EPAY_RECAPTCHA';

// If not set in config default value to 35 days or 3,024,000 seconds
const COOKIE_MAX_AGE_SECONDS: number = Number(process.env.VUE_APP_RECAPTCHA_COOKIE_MAX_AGE_SECONDS) || 3024000;

const enableRecaptcha =  ref(false);

function createRecaptchaCookie(value: string, maxAge = COOKIE_MAX_AGE_SECONDS) {
    const { setCookie } = useCookieUtils();
    setCookie(COOKIE_ID, value, maxAge, 'strict');
}

function lookupRecaptchaCookie() {
    const { getCookie } = useCookieUtils();
    return getCookie( COOKIE_ID );
}

function recaptchaEnabled() {
    return enableRecaptcha.value;
}

function setEnableRecaptcha(flag: boolean) {
    enableRecaptcha.value = flag;
}

function shouldShowRecaptcha() {
    if (!enableRecaptcha.value) {
        return false;
    }
    const { isAuthenticated } = useAuth();
    if (isAuthenticated.value) {
        return false;
    }
    const existingRecaptchaCookie = lookupRecaptchaCookie();
    return !existingRecaptchaCookie;
}

interface RecaptchaResponse {
    success: boolean;
    errorCodes?: string[];
    challenge_ts?: string;
}

async function validateRecaptchaToken(token: string): Promise<RecaptchaResponse> {
    const result = await API.get('API', `/v1/recaptcha/${token}`, {});
    if (result.success) {
        createRecaptchaCookie(`${result.challenge_ts}`, COOKIE_MAX_AGE_SECONDS)
        return result;
    }
    throw new Error('recaptcha validate failed');
}
